import * as React from 'react'

/**
 * O que a página pode pedir ao shell sobre a moldura em volta dela.
 *
 * Hoje é uma coisa só: o **modo apresentação** do Caderno (20 §4.4), em que
 * sidebar e topbar somem e o conteúdo perde a largura máxima — a nota vai para
 * o telão e o resto do Hub não tem o que fazer lá. Fica num contexto, e não num
 * parâmetro de rota, porque é estado de tela: recarregar volta ao Hub normal.
 */
export interface ShellChrome {
  presenting: boolean
  setPresenting: (presenting: boolean) => void
}

const ShellChromeContext = React.createContext<ShellChrome>({
  presenting: false,
  setPresenting: () => undefined,
})

export function ShellChromeProvider({ children }: { children: React.ReactNode }) {
  const [presenting, setPresenting] = React.useState(false)
  const value = React.useMemo(() => ({ presenting, setPresenting }), [presenting])
  return <ShellChromeContext.Provider value={value}>{children}</ShellChromeContext.Provider>
}

export function useShellChrome(): ShellChrome {
  return React.useContext(ShellChromeContext)
}

/**
 * Liga o modo apresentação enquanto `active` for verdadeiro e desliga ao sair
 * da página — trocar de rota nunca deixa o Hub sem sidebar.
 */
export function usePresentingChrome(active: boolean): void {
  const { setPresenting } = useShellChrome()
  React.useEffect(() => {
    if (!active) return
    setPresenting(true)
    return () => setPresenting(false)
  }, [active, setPresenting])
}
